"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const localStore_1 = require("../../data/localStore");
const SelectOption_1 = __importDefault(require("./SelectOption"));
const _examples_1 = __importDefault(require("../../data/examples/_examples"));
const OpenFileButton_1 = __importDefault(require("./OpenFileButton"));
class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saveName: "sculpture_one",
            loaded: []
        };
        this.save = () => {
            const { project } = this.props;
            if (this.state.saveName.length > 2) {
                localStore_1.saveSculpture(this.state.saveName, project);
                this.props.close();
            }
            else {
                window.alert("Must provide a name with a length of at least 3 characters");
            }
        };
    }
    componentDidMount() {
        this.setState({ loaded: localStore_1.loadSculptures() });
    }
    render() {
        if (this.props.open) {
            const renderOptions = [5, 6, 7, 8, 9, 10, 12, 15].map(el => el.toString());
            return (React.createElement("div", { className: "menuBackground", onClick: this.props.close },
                React.createElement("div", { className: "menuContainer", onClick: evt => evt.stopPropagation() },
                    React.createElement("h2", null, "Menu"),
                    React.createElement("div", { className: "menuColumns" },
                        React.createElement("div", { className: "menuColumn" },
                            React.createElement("h4", null, "This Sculpture"),
                            React.createElement("input", { onChange: evt => this.setState({ saveName: evt.target.value }), defaultValue: this.state.saveName }),
                            React.createElement("a", { className: "little-button", onClick: this.save },
                                "Save as ",
                                this.state.saveName),
                            React.createElement("a", { className: "little-button", onClick: this.props.download }, "Download"),
                            React.createElement("h4", null, "Reset (New)"),
                            React.createElement("a", { className: "little-button", onClick: () => {
                                    this.props.close();
                                    this.props.resetProject();
                                } }, "New Sculpture")),
                        React.createElement("div", { className: "menuColumn" },
                            React.createElement("h4", null, "Load Sculpture"),
                            this.state.loaded.map((item, i) => (React.createElement("a", { key: i, className: "little-button", onClick: () => {
                                    this.props.load(item.project);
                                    this.props.close();
                                } }, item.name))),
                            React.createElement("h4", null, "Load from Computer"),
                            React.createElement(OpenFileButton_1.default, { label: "Open from Computer", onOpen: project => {
                                    const rules = JSON.parse(project);
                                    this.props.load(rules);
                                    this.props.close();
                                } })),
                        React.createElement("div", { className: "menuColumn" },
                            React.createElement("h4", null, "Examples"),
                            _examples_1.default.map(({ rules, name }, i) => (React.createElement("a", { key: i, className: "little-button", onClick: () => {
                                    this.props.load(rules);
                                    this.props.close();
                                } }, name)))),
                        React.createElement("div", { className: "menuColumn" },
                            React.createElement("h4", null, "Rendering Rounds"),
                            React.createElement(SelectOption_1.default, { options: renderOptions, names: renderOptions, onChange: val => this.props.setIterations(parseInt(val)), value: this.props.iterations.toString() }),
                            React.createElement("p", null, "Maximum rounds of rule applications: a high value here might crash the page!"))))));
        }
        else {
            return null;
        }
    }
}
exports.default = Menu;



// WEBPACK FOOTER //
// ./src/components/editor/Menu.tsx